import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import img1 from "../../assets/images/profile.svg";
import comma from "../../assets/images/comma.svg";

type SlideType = {
  img: string;
  name: string;
  title: string;
  text: string;
};

const testimonials: SlideType[] = [
  {
    img: img1,
    name: "Adam Smith",
    title: "CEO & Founder (Start Engine)",
    text: "With John Bostjancic's guidance, we've navigated financial complexities and achieved remarkable success in our industry.",
  },
  {
    img: img1,
    name: "Sam Lopez",
    title: "Founder & Manager (BeSpoke Inc.)",
    text: "Thanks to John Bostjancic's leadership, we’ve strengthened our financial foundation and achieved sustainable success.",
  },
  {
    img: img1,
    name: "Maria Carl",
    title: "Partner (Lockheed Martin)",
    text: "Working with John Bostjancic has elevated our financial strategies and helped us navigate industry challenges with ease.",
  },
  {
    img: img1,
    name: "Paul Sandra",
    title: "CEO & Partner (Fidelity Investments)",
    text: "John Bostjancic’s strategic financial guidance led to remarkable growth and long-term stability for our business.",
  },
];
const Testamonial = () => {
  const [isNextClick, setIsNextClick] = useState(false);
  const [isPrevClick, setIsPrevClick] = useState(false);
  return (
    <div className="max-w-screen-2xl mx-auto pl-4 sm:pl-20 py-8 sm:py-28 overflow-hidden">
      <div className="flex flex-col lg:flex-row lg:h-[450px]">
        <div className="lg:w-[45%] flex flex-col justify-start">
          <div className="flex justify-center mb-10">
            <img src={comma} alt="" className="" />
          </div>
          <div className="relative mb-9 ml-5 lg:ml-0">
            <h3 className="poppins-regular text-primary z-20 relative">
              CLIENTS TESTIMONIALS
            </h3>
            <div className="size-16 bg-[#E7E9FF] rounded-full absolute -top-5 -left-5"></div>
          </div>
          <p className="mb-10">
            With over 30 years of financial expertise in healthcare, I offer a
            range of specialized services to drive growth, stability, and
            innovation within the medical sector.
          </p>

          <div className="flex gap-4 lg:self-end sm:mr-6">
            <button className="prev-btn">
              <svg
                width="12"
                height="20"
                viewBox="0 0 12 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.7224 1.24951C10.9802 1.50736 11.125 1.85703 11.125 2.22163C11.125 2.58623 10.9802 2.9359 10.7224 3.19376L3.91617 10L10.7224 16.8063C10.9729 17.0656 11.1115 17.4129 11.1083 17.7734C11.1052 18.134 10.9606 18.4788 10.7057 18.7338C10.4507 18.9887 10.1059 19.1333 9.74534 19.1364C9.38482 19.1396 9.0375 19.001 8.77817 18.7505L0.999792 10.9721C0.742019 10.7143 0.59721 10.3646 0.59721 10C0.59721 9.6354 0.742019 9.28573 0.999792 9.02788L8.77817 1.24951C9.03602 0.991732 9.38569 0.846924 9.75029 0.846924C10.1149 0.846924 10.4646 0.991732 10.7224 1.24951Z"
                  className={`${
                    isPrevClick ? "fill-primary" : "fill-gray-500"
                  }`}
                />
              </svg>
            </button>
            <button className="next-btn">
              <svg
                width="12"
                height="20"
                viewBox="0 0 12 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.27758 1.24951C1.01981 1.50736 0.875 1.85703 0.875 2.22163C0.875 2.58623 1.01981 2.9359 1.27758 3.19376L8.08383 10L1.27758 16.8063C1.02711 17.0656 0.888522 17.4129 0.891655 17.7734C0.894788 18.134 1.0394 18.4788 1.29433 18.7338C1.54927 18.9887 1.89413 19.1333 2.25466 19.1364C2.61518 19.1396 2.9625 19.001 3.22183 18.7505L11.0002 10.9721C11.258 10.7143 11.4028 10.3646 11.4028 10C11.4028 9.6354 11.258 9.28573 11.0002 9.02788L3.22183 1.24951C2.96398 0.991732 2.61431 0.846924 2.24971 0.846924C1.88511 0.846924 1.53543 0.991732 1.27758 1.24951Z"
                  className={`${
                    isNextClick ? "fill-primary" : "fill-gray-500"
                  }`}
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="lg:w-[55%] relative flex items-center">
          <div className=" h-[500px] w-full bg-gradient-to-b from-primary to-primary/50  absolute -right-32"></div>
          <div className="flex w-full gap-2 py-10">
            <Swiper
              modules={[Navigation]}
              autoplay={true}
              spaceBetween={28}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 1.7,
                },
              }}
              navigation={{
                nextEl: ".next-btn",
                prevEl: ".prev-btn",
              }}
              loop
              onNavigationNext={() => {
                setIsNextClick(true);
                setIsPrevClick(false);
              }}
              onNavigationPrev={() => {
                setIsPrevClick(true);
                setIsNextClick(false);
              }}
            >
              {testimonials.map((item, index) => (
                <SwiperSlide key={index} className="">
                  <div className="px-10 py-12 bg-white rounded-md drop-shadow-xl">
                    <div className="flex items-center gap-3 mb-4">
                      <div className=" rounded-full">
                        <img src={item.img} alt="" className="size-20" />
                      </div>
                      <div className="flex flex-col justify-end">
                        <h5 className="text-primary montserrat-semibold">
                          {item.name}
                        </h5>
                        <p className="montserrat-regular">{item.title}</p>
                      </div>
                    </div>
                    <div className="">
                      <p className="poppins-regular">{item.text}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testamonial;
